import { PassengerType } from "../../../validation/types";
var PassengerType_default = PassengerType;
export {
  PassengerType_default as default
};
